//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getToday, getAppointNMonth } from '~/assets/js/utils.js'
import pieCharts from '~/components/home/fundsFlowdatails/pieCharts.vue'
import barCharts from '~/components/home/fundsFlowdatails/barCharts.vue'
import nvBarCharts from '~/components/home/fundsFlowdatails/nvBarCharts.vue'
import wikiSelect from '~/components/common/wikiSelect.vue'
export default {
  components: {
    pieCharts,
    barCharts,
    nvBarCharts,
    wikiSelect
  },
  props: {
    tradeTrend: {
      type: Object, default: () => ({})
    },
    cashInOut: {
      type: Object, default: () => ({})
    },
    rankForCash: {
      type: Object, default: () => ({})
    }
  },
  data () {
    return {
      select: { value: 1, label: 'TYY_000748' },
      optionList: [
        {
          label: 'TYY_000748', // 近一个月
          value: 1
        },
        {
          label: 'TYY_000749', // 近三个月
          value: 2
        },
        {
          label: 'TYY_000750', // 近半年
          value: 3
        }
      ],
      updateTime: '', // 更新时间
      pieData: [
        { value: 0, symbol: '流入' },
        { value: 0, symbol: '流出' }
      ],
      colorArray: ['rgba(46, 153, 135, 1)', 'rgba(199, 52, 76, 1)'],
      fundsFlowInfo: {}, // 资金流转数据
      historyBarData: [], // 历史流转折线图数据
      fundsFlowRankInfo: [], // 排行数据
      isRequest: true
    }
  },
  mounted () {
    // 数据更新时间
    this.updateTime = this.tradeTrend.updatetime
    // 30天净流入
    this.pieData[0].value = this.cashInOut?.totalCashIn
    this.pieData[1].value = Math.abs(this.cashInOut?.totalCashOut)
    // 历史流转
    this.fundsFlowInfo = this.cashInOut
    this.historyBarData = this.fundsFlowInfo?.cashInOut_historyData?.reverse()
    // 交易商流入排行
    this.fundsFlowRankInfo = this.rankForCash?.brokerRankForCash
    this.fundsFlowRankInfo = this.fundsFlowRankInfo?.reverse()
  },
  methods: {
    changeOption (e) {
      const val = e.value
      if (val === 1) {
        this.getRankData(2)
        this.getData(getAppointNMonth('', 1), getToday())
      } else if (val === 2) {
        this.getRankData(3)
        this.getData(getAppointNMonth('', 3), getToday())
      } else {
        this.getRankData(4)
        this.getData(getAppointNMonth('', 6), getToday())
      }
    },
    // 获取左侧 资金流转数据
    async getData (startTime = getAppointNMonth('', 1), endTime = getToday()) {
      try {
        const res = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/cashInOut' }, { startTime, endTime })
        this.fundsFlowInfo = res
        this.historyBarData = res?.cashInOut_historyData?.reverse()
        this.pieData[0].value = res?.totalCashIn
        this.pieData[1].value = Math.abs(res?.totalCashOut)
      } catch (err) {}
    },
    // 获取资金流转数据
    async getRankData (period = 2) {
      try {
        // 3 //周期 2:1个月, 3:3个月, 4:6个月, 5:12个月, 6:24个月
        const res = await this.$api.common.invokeClient({ HttpMethod: 'post', Route: '/mt4Extend/brokerRankForCash' }, { period })
        this.fundsFlowRankInfo = res?.brokerRankForCash?.reverse()
      } catch (err) {}
    }
  }
}
